export const formatPrice = (value: number): string => {
    const amount = Math.round(Number.isFinite(value) ? value : 0)
    const grouped = String(Math.abs(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return `${amount < 0 ? '-' : ''}€${grouped}`
}

export const parseStringArray = (value: unknown): Array<string> => {
    if (Array.isArray(value)) return value.map(item => String(item).trim()).filter(Boolean)

    if (typeof value !== 'string' || value.trim() === '') return []

    try {
        const parsed: unknown = JSON.parse(value)

        if (Array.isArray(parsed)) return parsed.map(item => String(item).trim()).filter(Boolean)
    }

    catch {
        return value.split(',').map(item => item.trim()).filter(Boolean)
    }

    return []
}

export const mapsUrl = (address: string): string =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`

export const telHref = (phone: string): string =>
    `tel:${phone.replace(/[^\d+]/g, '')}`

export const pluralize = (count: number, singular: string, plural: string): string =>
    count === 1 ? singular : plural
